/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { Theme } from "@mui/material";

export const accountDeleteStyle = {
  firstCol: (theme: Theme) => ({
    height: "100%",
    padding: { xs: "0 0 2rem 0", md: "0 2rem 0 0" },
    borderRight: { md: `1px solid ${theme.palette.divider}` },
    borderBottom: { xs: `1px solid ${theme.palette.divider}`, md: "none" },
  }),
  linkWrapper: { flexGrow: 1, justifyContent: "flex-end", alignItems: { xs: "center", md: "start" } },
  link: { display: "inline-block", marginTop: "1rem" },
};
